(function() {
  "use strict";

  angular
    .module("sempraWebapp")
    .service("inputValidationService", inputValidationService);

  /** @ngInject */
  function inputValidationService() {
    //Numbers from 1 to 32 are valid
    this.numberOnlyFromTo = function(number) {
      var isNumber = /^\d+$/.test(number),
        data;
      if (number < 1 || number > 32 || !isNumber) {
        data = true;
      } else {
        data = false;
      }
      return data;
    };
    //Max 30 characters
    this.maxLetters = function(letter) {
      var data;
      if (letter.length > 30) {
        data = true;
      } else {
        data = false;
      }
      return data;
    };
    //Decimals numbers are valid
    this.numberOnlyDecimal = function() {};
    //Only positive numbers are valid
    this.numberOnly = function(number, array) {
      var isNumber = /^\d+$/.test(number),
        data,
        check;
      array.forEach(function(item) {
        if (item.tokenWeight === "") return (check = true);
      });
      if (!isNumber) {
        data = true;
      } else {
        data = false;
      }
      return check ? check : data;
    };
    //Only single positive numbers is valid
    this.singleNumberOnly = function(number) {
      var isNumber = /^\d+$/.test(number);
      return !isNumber;
    };
    // Number between 1 and 99
    this.positiveNumberOnlyTo100 = function(number) {
      var isNumber = /^\d+$/.test(number),
        data;
      if (number < 1 || number > 99 || !isNumber) {
        data = true;
      } else {
        data = false;
      }
      return data;
    };

    // Validate IP addresses and ports
    this.validateInputs = function(list) {
      var reducedList = list.filter(function(item) {
        return item.checked;
      });

      var isValidated = function(data) {
        var ipAddressCheck = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
          data.ipAddress
        );

        var isNumber = /^\d+$/.test(data.port),
          portCheck;
        if (data.port < 1 || data.port > 65535 || !isNumber) {
          portCheck = false;
        } else {
          portCheck = true;
        }

        return ipAddressCheck && portCheck ? true : false;
      };

      return reducedList.every(isValidated);
    };
  }
})();
